import { render } from "./LiveLaunch.vue?vue&type=template&id=a316d05c&ts=true"
import script from "./LiveLaunch.vue?vue&type=script&lang=ts"
export * from "./LiveLaunch.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__